var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"avatar",staticClass:"iframe",attrs:{"scrolling":"no","allow":"autoplay","src":_vm.avatar.url}},[_vm._v(" Your browser doesn't support AI Avatar ")])}
var staticRenderFns = []

export { render, staticRenderFns }